import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { StaticQuery, graphql } from 'gatsby'

import Header from './header'
import Jumbotron from './jumbotron'
import './layout.css'

const Layout = ({ children }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}
    render={data => (
      <>
        <Helmet
          title={data.site.siteMetadata.title}
          meta={[
            { name: 'description', content: 'Somos un equipo conformado por publicistas, cineastas, diseñadores gráficos y gestores culturales pensando cada proyecto.' },
            { name: 'keywords', content: 'comunicacion, estrategia, diseño, publicidad, eventos' },
          ]}
        >
          <html lang="en" />
        </Helmet>
        <Header siteTitle={data.site.siteMetadata.title} />
        <Jumbotron />
        <div className="container">
          {children}
        </div>
        <footer style={{ background: 'white', padding: '2rem 0' }}>
          <div className="container">
            &copy; 2018 Once y Once, SRL. Todos los derechos reservados.
          </div>
        </footer>
      </>
    )}
  />
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
